import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { initializeAndAddCandidate } from 'redux/actions';
import { cacheKey } from 'appConstants';
import AddForm from './AddForm';
import { AppMessenger } from 'utils';
import { cache } from 'utils/cache';
/* eslint-disable id-match */
import { USER_INPUT_ACTION } from 'widgetActions';

export default function CandidateForm(props) {
  const dispatch = useDispatch();
  const { isAdding, candidate } = useSelector((state) => state.appReducer);

  const onSubmitCallback = ({ firstName, lastName, phoneNumber }) => {
    if (!isAdding) {
      const jobChatId = cache.get(cacheKey.JOB_CHAT_ID);
      dispatch(
        initializeAndAddCandidate({
          jobChatId,
          firstName,
          lastName,
          phoneNumber,
        }),
      );

      AppMessenger.sendMessageToWidget({ action: USER_INPUT_ACTION });
    }
  };

  if (!isAdding && candidate.id) {
    return <Redirect to="thread" />;
  }

  return (
    <div data-testid={props['data-testid']} className="candidate-form-container">
      <AddForm onSubmitCallback={onSubmitCallback} isAdding={isAdding} />
    </div>
  );
}

CandidateForm.propTypes = {
  'data-testid': PropTypes.string,
};
